import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type BulkDraftRollupInvoicesQueryVariables = Types.Exact<{
  input: Types.BulkDraftRollupInvoicesArgsInput;
}>;


export type BulkDraftRollupInvoicesQuery = { __typename?: 'QueryModel', customRollupInvoices: { __typename?: 'CustomRollupInvoiceQueryModel2', draftRollupInvoices: Array<{ __typename?: 'CustomRollupInvoice', invoiceNumber: string, total: number, lineItems: Array<{ __typename?: 'CustomRollupInvoiceLineItem', total: number, invoice: { __typename?: 'Invoice', invoiceNumber: string } }>, projectGroup: { __typename?: 'ProjectGroup', id: number } }> } };


export const BulkDraftRollupInvoicesDocument = gql`
    query BulkDraftRollupInvoices($input: BulkDraftRollupInvoicesArgsInput!) {
  customRollupInvoices {
    draftRollupInvoices(input: $input) {
      invoiceNumber
      lineItems {
        total
        invoice {
          invoiceNumber
        }
      }
      projectGroup {
        id
      }
      total
    }
  }
}
    `;

/**
 * __useBulkDraftRollupInvoicesQuery__
 *
 * To run a query within a React component, call `useBulkDraftRollupInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDraftRollupInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDraftRollupInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDraftRollupInvoicesQuery(baseOptions: Apollo.QueryHookOptions<BulkDraftRollupInvoicesQuery, BulkDraftRollupInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkDraftRollupInvoicesQuery, BulkDraftRollupInvoicesQueryVariables>(BulkDraftRollupInvoicesDocument, options);
      }
export function useBulkDraftRollupInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkDraftRollupInvoicesQuery, BulkDraftRollupInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkDraftRollupInvoicesQuery, BulkDraftRollupInvoicesQueryVariables>(BulkDraftRollupInvoicesDocument, options);
        }
export type BulkDraftRollupInvoicesQueryHookResult = ReturnType<typeof useBulkDraftRollupInvoicesQuery>;
export type BulkDraftRollupInvoicesLazyQueryHookResult = ReturnType<typeof useBulkDraftRollupInvoicesLazyQuery>;
export type BulkDraftRollupInvoicesQueryResult = Apollo.QueryResult<BulkDraftRollupInvoicesQuery, BulkDraftRollupInvoicesQueryVariables>;